import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { AiAssistantWidget } from './components/AiAssistantWidget';
import { Home } from './pages/Home';
import { BookingFlow } from './pages/BookingFlow';
import { SupplierResults } from './pages/SupplierResults';
import { Payment } from './pages/Payment';
import { LiveTracking } from './pages/LiveTracking';
import { Activity } from './pages/Activity';
import { EnterpriseDashboard } from './pages/EnterpriseDashboard';
import { MobileApp } from './pages/MobileApp';
import { DriverApp } from './pages/DriverApp';
import { PortalSelector } from './pages/PortalSelector';
import { ServiceUnavailable } from './pages/ServiceUnavailable';
import { LoginModal } from './components/LoginModal';
import { useLoginModal } from './lib/authStore';
import { useScreenInit } from './useScreenInit';
// Supplier Portal
import { SupplierLogin } from './pages/supplier/SupplierLogin';
import { SupplierRegister } from './pages/supplier/SupplierRegister';
import { SupplierDashboard } from './pages/supplier/SupplierDashboard';
import { SupplierDispatcher } from './pages/supplier/SupplierDispatcher';
import { SupplierTracking } from './pages/supplier/SupplierTracking';
import { SupplierRequests } from './pages/supplier/SupplierRequests';
import { SupplierHistory } from './pages/supplier/SupplierHistory';
import { SupplierPayments } from './pages/supplier/SupplierPayments';
import { SupplierPermits } from './pages/supplier/SupplierPermits';
import { SupplierTrucks } from './pages/supplier/SupplierTrucks';
import { SupplierDrivers } from './pages/supplier/SupplierDrivers';
import { SupplierReports } from './pages/supplier/SupplierReports';
import { SupplierProfile } from './pages/supplier/SupplierProfile';
import { useSupplierAuth } from './lib/supplierAuthStore';
import { Toaster } from 'sonner';
function AppContent() {
  useScreenInit();
  const location = useLocation();
  const isSupplierPortal = location.pathname.startsWith('/supplier');
  // Hide nav + widget on the portal selector, mobile mockup, and entire supplier portal.
  const hiddenNav = ['/', '/mobile', '/driver'];
  const showNav = !hiddenNav.includes(location.pathname) && !isSupplierPortal;
  const hiddenAi = ['/', '/mobile', '/driver', '/booking', '/payment'];
  const showAiWidget = !hiddenAi.includes(location.pathname) && !isSupplierPortal;
  return <div className={`min-h-screen bg-surface-100 font-sans text-gray-900 ${showNav ? 'pt-20' : ''}`} data-id="element-0">
      {showNav && <Navbar data-id="element-1" />}
      <main className="w-full" data-id="element-2">
        <Routes data-id="element-3">
          <Route path="/" element={<PortalSelector data-id="element-5" />} data-id="element-4" />
          <Route path="/marketplace" element={<Home data-id="element-7" />} data-id="element-6" />
          <Route path="/booking" element={<BookingFlow data-id="element-9" />} data-id="element-8" />
          <Route path="/results" element={<SupplierResults data-id="element-11" />} data-id="element-10" />
          <Route path="/payment" element={<Payment data-id="element-13" />} data-id="element-12" />
          <Route path="/tracking" element={<LiveTracking data-id="element-15" />} data-id="element-14" />
          <Route path="/activity" element={<Activity data-id="element-17" />} data-id="element-16" />
          <Route path="/enterprise" element={<EnterpriseDashboard data-id="element-19" />} data-id="element-18" />
          {/* Supplier Portal */}
          <Route path="/supplier" element={<Navigate to="/supplier/dashboard" replace data-id="element-21" />} data-id="element-20" />
          <Route path="/supplier/login" element={<SupplierLogin data-id="element-23" />} data-id="element-22" />
          <Route path="/supplier/register" element={<SupplierRegister data-id="element-25" />} data-id="element-24" />
          <Route path="/supplier/dashboard" element={<SupplierDashboard data-id="element-27" />} data-id="element-26" />
          <Route path="/supplier/dispatcher" element={<SupplierDispatcher data-id="element-29" />} data-id="element-28" />
          <Route path="/supplier/tracking" element={<SupplierTracking data-id="element-31" />} data-id="element-30" />
          <Route path="/supplier/requests" element={<SupplierRequests data-id="element-33" />} data-id="element-32" />
          <Route path="/supplier/history" element={<SupplierHistory data-id="element-35" />} data-id="element-34" />
          <Route path="/supplier/permits" element={<SupplierPermits data-id="element-37" />} data-id="element-36" />
          <Route path="/supplier/payments" element={<SupplierPayments data-id="element-39" />} data-id="element-38" />
          <Route path="/supplier/reports" element={<SupplierReports data-id="element-41" />} data-id="element-40" />
          <Route path="/supplier/trucks" element={<SupplierTrucks data-id="element-43" />} data-id="element-42" />
          <Route path="/supplier/drivers" element={<SupplierDrivers data-id="element-45" />} data-id="element-44" />
          <Route path="/supplier/profile" element={<SupplierProfile data-id="element-47" />} data-id="element-46" />
          <Route path="/mobile" element={<MobileApp data-id="element-49" />} data-id="element-48" />
          <Route path="/driver" element={<DriverApp data-id="element-51" />} data-id="element-50" />
          <Route path="/unavailable" element={<ServiceUnavailable data-id="element-53" />} data-id="element-52" />
        </Routes>
      </main>
      {showAiWidget && <AiAssistantWidget data-id="element-54" />}
      <GlobalLoginModal data-id="element-55" />
      <Toaster richColors position="top-center" data-id="element-56" />
    </div>;
}
function GlobalLoginModal() {
  const {
    isOpen,
    close
  } = useLoginModal();
  return <LoginModal open={isOpen} onClose={close} data-id="element-57" />;
}
export function App() {
  return <Router data-id="element-58">
      <AppContent data-id="element-59" />
    </Router>;
}